import UserService from '@/services/user.service';
import LoginService from '@/services/login.service';
import ClientService from '../services/client.service';
var loginService = new LoginService();
var userService = new UserService();
var clientService = new ClientService();

var check = function() {
    var stringUser = localStorage.getItem('myuser');
    var user = null;
    if (stringUser !== null) {
        user = JSON.parse(stringUser);
    }
    var isCredential =  user;
    var result = false;
    if (isCredential !== null) {
        result = true;
    }
    return result;
}

var getMyUser = function() {
    var stringUser = localStorage.getItem('myuser');
    var user = null;
    if (stringUser !== null) {
        user = JSON.parse(stringUser);
    }
    return user
}

var install = function (Vue, options) {
    Vue.prototype.$auth = {};

    /**
     * Get the authentication token to use in the API.
     * 
     * @return {string}
     */
    Vue.prototype.$auth.token = function() {
        return localStorage.getItem('credential');
    };



    /**
     * Set the authentication parameters and validate the authentication.
     * 
     * @param {string} username
     * @param {string} password
     * @return {Promise}
     */
    Vue.prototype.$auth.setUsernamePassword = function(username, password) {
        return new Promise((done, reject) => {
            var b64 = btoa(username + ':' + password);
            this.setCredential(b64);
            this.validateWithServer().then(()=> {
                done();
            }).catch(() => {
                reject();
            });
        });
    }

    /**
     * Check if a user is currently authenticated.
     * 
     * @return {boolean}
     */
    Vue.prototype.$auth.check = function() {
        var isCredential = this.getMyUser();
        var result = false;
        if (isCredential !== null) {
            result = true;
        }
        return result;
    }

    /**
     * Logout the current user by removing the credentials.
     * 
     * @return {}
     */
    Vue.prototype.$auth.logout = function() {
        try {
            localStorage.removeItem('myview');
        } catch (e) {}
        localStorage.removeItem('myuser');
        localStorage.removeItem('credential');
    }

    /**
     * Get the current user infos.
     * 
     * @return {User}
     */
    Vue.prototype.$auth.getMyUser = function() {
        var stringUser = localStorage.getItem('myuser');
        var user = null;
        if (stringUser !== null) {
            user = JSON.parse(stringUser);
        }
        return user;
    }

    /**
     * Set the user.
     * 
     * @param {User}
     */
    Vue.prototype.$auth.setMyUser = function(user) {
        localStorage.setItem('myuser', JSON.stringify(user));
    }

    /**
     * Get the roles of the authenticated user.
     * 
     * @return {[string]}
     */
    Vue.prototype.$auth.getRoles = function() {
        var stringUser = localStorage.getItem('myuser');
        var user = null;
        if (stringUser !== null) {
            user = JSON.parse(stringUser);
        }
        return user.roles;
    }

    /**
     * Set the view of the user.
     * 
     * @param {User}
     */
    Vue.prototype.$auth.setMyView = function(view) {
        localStorage.setItem('myview', view);
    }

    /**
     * Remove the view of the user.
     * 
     * @param {User}
     */
    Vue.prototype.$auth.removeMyView = function() {
        localStorage.removeItem('myview');
    }

    /**
     * Get the view of the user.
     * 
     * @return {[string]}
     */
    Vue.prototype.$auth.getMyView = function() {
        var stringview = localStorage.getItem('myview');
        var view = null;
        if (stringview !== null) {
            view = stringview;
        }
        return view;
    }

    /**
     * Set the view of the client.
     * 
     * @param {User}
     */
    Vue.prototype.$auth.setMyClientView = function(view) {
        localStorage.setItem('myclientview', view);
        this.loadMyClientViewObject().catch(err => {});
    }

    /**
     * Remove the view of the client.
     * 
     * @param {User}
     */
    Vue.prototype.$auth.removeMyClientView = function() {
        localStorage.removeItem('myclientview');
    }

    /**
     * Get the view of the client.
     * 
     * @return {[string]}
     */
    Vue.prototype.$auth.getMyClientView = function() {
        var stringview = localStorage.getItem('myclientview');
        var view = null;
        if (stringview !== null) {
            view = stringview;
        }
        return view;
    }

    /**
     * Get the view of the client.
     * 
     * @return {[string]}
     */
     Vue.prototype.$auth.getMyClientViewObject = function() {
        var stringview = localStorage.getItem('myclientviewobject');
        var view = null;
        if (stringview !== null) {
            try {
                view = JSON.parse(stringview);
            } catch(err) {}
        }
        return view;
    }

    /**
     * Get the view of the client.
     * 
     * @return {[string]}
     */
     Vue.prototype.$auth.loadMyClientViewObject = function() {
        return new Promise((done, reject) => {
            clientService.getClient(this.getMyClientView(), this.token()).then(client => {
                try {
                    localStorage.setItem('myclientviewobject', JSON.stringify(client));
                } catch(err) {}
                done(client);
            }).catch(err => {
                localStorage.setItem('myclientviewobject', '{}');
                reject(err);
            })
        })
    }

    /**
     * Validate the token with the server.
     * 
     * @return {Promise}
     */
    Vue.prototype.$auth.validateWithServer = function() {
        return new Promise((done, reject) => {
                userService.getMyUser(this.token()).then((user) => {
                    this.setMyUser(user);
                    loginService.postLogin({type: 'login'},this.token()).then(()=>{}).catch(err => {});
                    done();
                }).catch(() => {
                    try {
                        localStorage.removeItem('myview');
                    } catch (e) {}
                    localStorage.removeItem('myuser');
                    localStorage.removeItem('credential');
                    reject();
                });
            });
    }

    /**
     * Set the credential.
     * 
     * @param {string} credential
     */
    Vue.prototype.$auth.setCredential = function(credential) {
        localStorage.setItem('credential', credential);
    }

}
export default {
    install,
    getMyUser,
    check
}